import { ReflectionValue } from './reflection.value';

export class ReflectionValueDto {
    name: string;
    questionText: string;

    constructor(data: ReflectionValue) {
        this.name = data.name;
        this.questionText = data.questionText;
    }
}
